/**
 * THIS FILE IS AUTO-GENERATED, DO NOT EDIT
 */

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "ConnectionFilter": [
      "AppointmentConnectionFilter",
      "ConversationConnectionFilter",
      "LeadConnectionFilter",
      "RetailItemConnectionFilter",
      "TaskConnectionFilter",
      "TradeInItemConnectionFilter"
    ],
    "Event": [
      "ConversationConnectionUpdatedEvent",
      "ConversationItemCreatedEvent",
      "LeadActivityConnectionUpdatedEvent",
      "PushNotificationEvent"
    ],
    "Filter": [
      "DateTimeFilter",
      "FacetFilter",
      "RangeFilter",
      "ToggleGroupFilter"
    ],
    "Identity": [
      "Contact",
      "Lead",
      "User"
    ],
    "IncentiveAttributes": [
      "InterestRateDiscountIncentiveAttributes",
      "InterestRateIncentiveAttributes",
      "PurchasePriceFixedByTermIncentiveAttributes",
      "PurchasePriceFixedIncentiveAttributes",
      "PurchasePricePercentageIncentiveAttributes",
      "ResidualRateIncentiveAttributes"
    ],
    "InventoryItem": [
      "RetailItem",
      "TradeInItem"
    ],
    "InventoryItemAttributes": [
      "MotorcycleAttributes",
      "VehicleAttributes"
    ],
    "InventoryItemFilter": [
      "RetailItemConnectionFilter"
    ],
    "InventoryItemSpecificationAttributes": [
      "VehicleSpecificationAttributes"
    ],
    "LeadActivityAttributes": [
      "DepositLeadActivityAttributes",
      "FormLeadActivityAttributes",
      "InquiryLeadActivityAttributes",
      "PhoneCallLeadActivityAttributes",
      "PurchaseLeadActivityAttributes",
      "SubscriptionChangeLeadActivityAttributes",
      "TestDriveLeadActivityAttributes",
      "TradeInLeadActivityAttributes",
      "WalkInLeadActivityAttributes"
    ],
    "ManufacturerOption": [
      "ManufacturerVehicleOption"
    ],
    "MediaGalleryItem": [
      "InventoryItemPhoto",
      "InventoryItemVideo",
      "MediaGalleryAdjustmentPhoto",
      "MediaGalleryAdjustmentVideo"
    ],
    "PaymentCalculation": [
      "CashPaymentCalculation",
      "FinancePaymentCalculation",
      "LeasePaymentCalculation"
    ],
    "RetailBulkAdjustmentAttributes": [
      "DescriptionRetailBulkAdjustmentAttributes",
      "DisclaimerRetailBulkAdjustmentAttributes",
      "EBlockSubmitRetailBulkAdjustmentAttributes",
      "MediaGalleryRetailBulkAdjustmentAttributes",
      "OverlayRetailBulkAdjustmentAttributes",
      "PhotoBackgroundRetailBulkAdjustmentAttributes",
      "PriceRetailBulkAdjustmentAttributes",
      "PromotionRetailBulkAdjustmentAttributes"
    ],
    "RetailItemIntegrationAttributes": [
      "EBlockRetailItemIntegrationAttributes"
    ],
    "RetailPricing": [
      "CashRetailPricing",
      "FinanceRetailPricing",
      "LeaseRetailPricing"
    ],
    "RetailPricingConfiguration": [
      "CashRetailPricingConfiguration",
      "FinanceRetailPricingConfiguration",
      "LeaseRetailPricingConfiguration"
    ],
    "RooftopIntegrationAttributes": [
      "CppRooftopIntegrationAttributes",
      "EBlockRooftopIntegrationAttributes",
      "InventoryExportRooftopIntegrationAttributes",
      "InventoryImportRooftopIntegrationAttributes",
      "LeadDistributionRooftopIntegrationAttributes",
      "OemAccountExportRooftopIntegrationAttributes",
      "PaymentProviderRooftopIntegrationAttributes",
      "PhoneCallTrackingRooftopIntegrationAttributes",
      "PricingRooftopIntegrationAttributes"
    ],
    "TradeInAppraisal": [
      "TradeInAppraisalExternal",
      "TradeInAppraisalInternal"
    ],
    "WebsiteTarget": [
      "PortalWebsite",
      "Website"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ConnectionFilter": [
      "AppointmentConnectionFilter",
      "ConversationConnectionFilter",
      "LeadConnectionFilter",
      "RetailItemConnectionFilter",
      "TaskConnectionFilter",
      "TradeInItemConnectionFilter"
    ],
    "Event": [
      "ConversationConnectionUpdatedEvent",
      "ConversationItemCreatedEvent",
      "LeadActivityConnectionUpdatedEvent",
      "PushNotificationEvent"
    ],
    "Filter": [
      "DateTimeFilter",
      "FacetFilter",
      "RangeFilter",
      "ToggleGroupFilter"
    ],
    "Identity": [
      "Contact",
      "Lead",
      "User"
    ],
    "IncentiveAttributes": [
      "InterestRateDiscountIncentiveAttributes",
      "InterestRateIncentiveAttributes",
      "PurchasePriceFixedByTermIncentiveAttributes",
      "PurchasePriceFixedIncentiveAttributes",
      "PurchasePricePercentageIncentiveAttributes",
      "ResidualRateIncentiveAttributes"
    ],
    "InventoryItem": [
      "RetailItem",
      "TradeInItem"
    ],
    "InventoryItemAttributes": [
      "MotorcycleAttributes",
      "VehicleAttributes"
    ],
    "InventoryItemFilter": [
      "RetailItemConnectionFilter"
    ],
    "InventoryItemSpecificationAttributes": [
      "VehicleSpecificationAttributes"
    ],
    "LeadActivityAttributes": [
      "DepositLeadActivityAttributes",
      "FormLeadActivityAttributes",
      "InquiryLeadActivityAttributes",
      "PhoneCallLeadActivityAttributes",
      "PurchaseLeadActivityAttributes",
      "SubscriptionChangeLeadActivityAttributes",
      "TestDriveLeadActivityAttributes",
      "TradeInLeadActivityAttributes",
      "WalkInLeadActivityAttributes"
    ],
    "ManufacturerOption": [
      "ManufacturerVehicleOption"
    ],
    "MediaGalleryItem": [
      "InventoryItemPhoto",
      "InventoryItemVideo",
      "MediaGalleryAdjustmentPhoto",
      "MediaGalleryAdjustmentVideo"
    ],
    "PaymentCalculation": [
      "CashPaymentCalculation",
      "FinancePaymentCalculation",
      "LeasePaymentCalculation"
    ],
    "RetailBulkAdjustmentAttributes": [
      "DescriptionRetailBulkAdjustmentAttributes",
      "DisclaimerRetailBulkAdjustmentAttributes",
      "EBlockSubmitRetailBulkAdjustmentAttributes",
      "MediaGalleryRetailBulkAdjustmentAttributes",
      "OverlayRetailBulkAdjustmentAttributes",
      "PhotoBackgroundRetailBulkAdjustmentAttributes",
      "PriceRetailBulkAdjustmentAttributes",
      "PromotionRetailBulkAdjustmentAttributes"
    ],
    "RetailItemIntegrationAttributes": [
      "EBlockRetailItemIntegrationAttributes"
    ],
    "RetailPricing": [
      "CashRetailPricing",
      "FinanceRetailPricing",
      "LeaseRetailPricing"
    ],
    "RetailPricingConfiguration": [
      "CashRetailPricingConfiguration",
      "FinanceRetailPricingConfiguration",
      "LeaseRetailPricingConfiguration"
    ],
    "RooftopIntegrationAttributes": [
      "CppRooftopIntegrationAttributes",
      "EBlockRooftopIntegrationAttributes",
      "InventoryExportRooftopIntegrationAttributes",
      "InventoryImportRooftopIntegrationAttributes",
      "LeadDistributionRooftopIntegrationAttributes",
      "OemAccountExportRooftopIntegrationAttributes",
      "PaymentProviderRooftopIntegrationAttributes",
      "PhoneCallTrackingRooftopIntegrationAttributes",
      "PricingRooftopIntegrationAttributes"
    ],
    "TradeInAppraisal": [
      "TradeInAppraisalExternal",
      "TradeInAppraisalInternal"
    ],
    "WebsiteTarget": [
      "PortalWebsite",
      "Website"
    ]
  }
};
      export default result;
    